import { render, staticRenderFns } from "./FileContent.vue?vue&type=template&id=c72d14ac"
import script from "./FileContent.vue?vue&type=script&lang=js"
export * from "./FileContent.vue?vue&type=script&lang=js"
import style0 from "./FileContent.vue?vue&type=style&index=0&id=c72d14ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports